// "Where your concepts stand" — a compact 5-tile summary of the mastery bins.
// Sits above the interactive MasteryBoard accordion; purely a glanceable count,
// no drag-and-drop here.
//
// Each tile is marked with its bin's SHAPE rather than a generic leaf: this is
// the most-glanced-at read of the ramp in the product, so it is the place the
// colour-only encoding hurt most.
import type { BinColor, TaskCardDTO } from '@/types';
import { BIN_LABEL, BIN_NOTE, BIN_ORDER, BIN_VAR_KEY } from '@/lib/bins';
import { BinGlyph } from '@/components/ds';
import type { DsBin } from '@/components/ds';

export function MasterySackGrid({ byBin }: { byBin: Record<BinColor, TaskCardDTO[]> }) {
  return (
    <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-5">
      {BIN_ORDER.map((bin) => {
        const key = BIN_VAR_KEY[bin];
        const count = byBin[bin]?.length ?? 0;
        return (
          <div key={bin} className="rounded-2xl p-3" style={{ background: `var(--${key}-bg)` }}>
            <div className="mb-2 flex items-center justify-between">
              <span style={{ color: `var(--${key}-text)`, display: 'inline-flex' }}>
                <BinGlyph bin={key as DsBin} size={15} color="currentColor" title={null} />
              </span>
              <span
                data-numeric=""
                className="text-xl font-extrabold"
                style={{ color: `var(--${key}-text)` }}
              >
                {count}
              </span>
            </div>
            <div className="text-xs font-bold leading-tight text-ink">{BIN_LABEL[bin]}</div>
            <div className="mt-0.5 text-fs-10.5 font-medium text-ink-faint">{BIN_NOTE[bin]}</div>
          </div>
        );
      })}
    </div>
  );
}
